import { render, staticRenderFns } from "./TrafficLight.vue?vue&type=template&id=ac823aa4"
import script from "./TrafficLight.ts?vue&type=script&lang=ts&external"
export * from "./TrafficLight.ts?vue&type=script&lang=ts&external"
import style0 from "./TrafficLight.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports